import { apiClient } from './client';

export interface InviteCreateResponse {
  success: boolean;
  token?: string;
  invite_url?: string;
  expires_at?: string;
  error?: string;
}

export interface InviteInfoResponse {
  success: boolean;
  status?: 'pending' | 'completed';
  question_id?: string;
  question_text?: string;
  initiator_name?: string;
  result_output?: string;
  completed_at?: string;
  expires_at?: string;
  error?: string;
}

export interface InviteSubmitResponse {
  success: boolean;
  question_id?: string;
  question_text?: string;
  initiator_name?: string;
  invitee_name?: string;
  result_output?: string;
  error?: string;
}

export interface MyInvite {
  token: string;
  question_text: string;
  status: 'pending' | 'completed';
  invitee_name: string | null;
  expires_at: string;
  created_at: string;
  completed_at: string | null;
}

export const createInvite = async (
  question_id: string,
  initiator_name: string,
  initiator_birth_time: string,
  initiator_gender: 'Male' | 'Female'
): Promise<InviteCreateResponse> => {
  const res = await apiClient.post<InviteCreateResponse>('/api/pair/invite', {
    question_id,
    initiator_name,
    initiator_birth_time,
    initiator_gender,
  });
  return res as any as InviteCreateResponse;
};

export const getInviteInfo = async (token: string): Promise<InviteInfoResponse> => {
  const res = await apiClient.get<InviteInfoResponse>(`/api/pair/invite/${token}`);
  return res as any as InviteInfoResponse;
};

export const submitInvite = async (
  token: string,
  invitee_name: string,
  invitee_birth_time: string,
  invitee_gender: 'Male' | 'Female'
): Promise<InviteSubmitResponse> => {
  const res = await apiClient.post<InviteSubmitResponse>(`/api/pair/invite/${token}/submit`, {
    invitee_name,
    invitee_birth_time,
    invitee_gender,
  });
  return res as any as InviteSubmitResponse;
};

export const getMyInvites = async (): Promise<{ success: boolean; invites: MyInvite[] }> => {
  const res = await apiClient.get<{ success: boolean; invites: MyInvite[] }>('/api/pair/invites');
  return res as any;
};
